import React, { FC } from 'react';
import i18n from 'i18n';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';

type UninstallTileModalProps = ModalProps

export const UninstallTileModal: FC<UninstallTileModalProps> = ({ app, onCancel, onSuccess, loading }) => {
  const actions: any[] = [];

  if (!loading) {
    actions.push({
      text: i18n('component.UninstallModal.CancelText')(),
      onClick: onCancel,
      variant: 'text',
      id: 'uninstall-button-cancel'
    });
  }

  actions.push({
    text: loading ? i18n('component.UninstallTileModal.loading')() : i18n('component.UninstallTileModal.UninstallText')(),
    onClick: onSuccess,
    variant: 'filled',
    id: 'uninstall-button-ok',
    disabled: loading
  });

  return (
    <Dialog
      show={true}
      id="UninstallTileModal"
      heroIcon="delete"
      title={i18n('component.UninstallTileModal.title')({ tileName: app.name })}
      message={i18n('component.UninstallTileModal.content')({ tileName: app.name })}
      onDismiss={loading ? undefined : onCancel}
      actions={actions}
    />
  );
};
